import React from 'react';

type DescriptionProps ={
  img: string,
  logo: string,
}

const Description: React.FC<DescriptionProps> = ({img, logo, ...props}) => {
  return (
    <div {...props} className="px-5">
      <div className="grid grid-cols-3">
        <div className="col-span-3 flex justify-center mx-2">
          <img className='' src={img} alt='' style={{height:'2.5rem'}}/>
        </div>
        {/* <div className="col-start-2 flex justify-center">
          <img src={logo} className="col-start-2 w-16"/>
        </div> */}
        <div className="col-span-3 mt-3">
          <p className="text-center text-gray-600">
            We are a software development company based in Brisbane Australia with users of our technologies across the globe.
            Our technology solutions enhance business operations to generate efficiency and improve user experience across multiple industries.
            We have been operating for 10 years and are 100% Australian owned with customer support services based in Brisbane.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Description;